import {
  ElectricityPowerSupplyType,
  GasMeter,
  MeterDestination,
  MeterElectricityTension,
  MeterElectricityType,
  MeterGasTechnicalCharacteristic,
  ModifiedConnection,
  PackageDTO,
  PackagedElectricityMeter
} from '@/models'

export interface CmhEnergyConfigurationState {
  packagedElectricityMeters: PackagedElectricityMeter[]
  modifiedConnections: ModifiedConnection[]
  gasMeters: GasMeter[]
  tensions: MeterElectricityTension[]
  tarifications: MeterElectricityType[]
  destinations: MeterDestination[]
  technicalCharacteristics: MeterGasTechnicalCharacteristic[],
  defaultPackagedElectricityMeter: PackagedElectricityMeter
  defaultModifiedConnection: ModifiedConnection
  defaultGasMeter: GasMeter
  isDefaultConfigurationOverriden: boolean
  meterElectricityPackages: PackageDTO[]
  initialPackagedElectricityMeters: PackagedElectricityMeter[]
}

const tensions: MeterElectricityTension[] = ['mono230V', 'tri230V', 'tri400V', 'custom']
const tarifications: MeterElectricityType[] = ['simple', 'dual', 'nightOnly', 'budget']
const destinations: MeterDestination[] = ['residential', 'professional', 'common', 'other']
const technicalCharacteristics: MeterGasTechnicalCharacteristic[] = ['standard', 'custom']

const defaultPackagedElectricityMeter: PackagedElectricityMeter = {
  count: 1,
  connectionType: ElectricityPowerSupplyType.unknown,
  remarks: null,
  package: {
    key: '',
    maximumPower: {
      voltAmpere: 0,
      kiloVoltAmpere: 0
    },
    homePrice: {
      exVat: 0,
      partialVat0: 0,
      partialVat06: 0,
      partialVat12: 0,
      vat21: 0
    },
    buildingPrice: {
      exVat: 0,
      partialVat0: 0,
      partialVat06: 0,
      partialVat12: 0,
      vat21: 0
    }
  },
  customPower: false,
  wantedPower: null,
  destination: null
}

const defaultModifiedConnection: ModifiedConnection = {
  type: 'dual',
  remarks: null,
  price: {
    exVat: 260,
    partialVat0: 260,
    partialVat06: 245.28,
    partialVat12: 291.2,
    vat21: 314.6
  },
  count: 1,
}
const defaultGasMeter: GasMeter = {
  count: 1, technicalCharacteristic: 'standard',
  destination: 'residential', power: 60, remarks: null
}
const meterElectricityPackages: PackageDTO[] = []

export const InitialState: CmhEnergyConfigurationState = {
  packagedElectricityMeters: [],
  modifiedConnections: [],
  gasMeters: [],
  tensions,
  tarifications,
  destinations,
  technicalCharacteristics,
  defaultPackagedElectricityMeter,
  defaultModifiedConnection,
  defaultGasMeter,
  isDefaultConfigurationOverriden: false,
  meterElectricityPackages,
  initialPackagedElectricityMeters: []
}
